export default __webpack_public_path__ + "img/woman.f9f36f5.svg";